import { FunctionComponentElement, useState } from "react";
import { NodeInputProps } from "./index";
import { MultiSelect } from "primereact/multiselect";
import { ErrorDefaultValueWidget } from "../error/errorDefaultValueWidget";

let reg = new RegExp(/(.*)\[(.*)\]/);
export const MultiChoice = (
  props: NodeInputProps
): FunctionComponentElement<NodeInputProps> => {
  const [incorrectDefaultValue, setIncorrectDefaultValue] =
    useState<boolean>(false);

  const verifyType = (value: any) => {
    if ( Array.isArray(value) ) {
      for(let i of value) {
        if(typeof i !== "string") {
          return false
        }
      }
    }else return false
    return true;
  };

  const [valueWidget, setValueWidget] = useState(() => {
    if (props.value) return props.value;
    if (props.defaultValue) {
      if (verifyType(props.defaultValue)) return props.defaultValue;
      else setIncorrectDefaultValue(true);
    }
    return undefined;
  });

  const [args] = useState<{ label: string; value: string }[] | undefined>(
    () => {
      let m = props.type.match(reg);
      if (m) {
        if (m.length > 1) {
          let tmp = m[2].split(";").map((c) => {
            return { label: c, value: c };
          });
          return tmp;
        }
        return undefined;
      }
      return undefined;
    }
  );

  return (
    <div>
      <ErrorDefaultValueWidget
        displayError={incorrectDefaultValue}
      ></ErrorDefaultValueWidget>
      <MultiSelect
        value={valueWidget}
        options={args}
        onChange={(e) => {
          props.onChange(e.value);
          setValueWidget(e.value);
          setIncorrectDefaultValue(false);
        }}
        placeholder={props.placeholder}
        display="chip"
        disabled={props.disabled}
      />
    </div>
  );
};
